import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQS } from "../data/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const FAQ = () => (
    <section id="faq" className="bg-white py-16 sm:py-24 lg:py-32" data-testid="faq-section">
        <div className="mx-auto max-w-4xl px-4 sm:px-8">
            <SectionHeading
                chapter="11"
                kicker="FAQ"
                title="Straight answers, no fine print."
                testid="faq-heading"
            />
            <Reveal delay={0.1}>
                <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
                    {FAQS.map((faq, i) => (
                        <AccordionItem key={i} value={`faq-${i}`} className="border-brand-brown/10">
                            <AccordionTrigger
                                data-testid={`faq-question-${i}`}
                                className="text-left font-display text-base font-semibold text-brand-brown transition-colors duration-200 hover:text-brand-orange sm:text-lg"
                            >
                                {faq.q}
                            </AccordionTrigger>
                            <AccordionContent
                                data-testid={`faq-answer-${i}`}
                                className="text-sm leading-relaxed text-brand-muted sm:text-base"
                            >
                                {faq.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);
